import React from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import getDisplayName from 'react-display-name';

export type WithDirection = {
  isRTL?: boolean;
};

export const withDirection = <P extends WithDirection>(Component: React.ComponentType<P>) => {
  class WithDirectionComponent extends React.Component<P> {
    static displayName = `withDirection(${getDisplayName(Component)})`;

    render() {
      return (
        <div dir={this.props.isRTL ? 'rtl' : undefined}>
          <Component {...this.props} />
        </div>
      );
    }
  }

  hoistNonReactStatics(WithDirectionComponent, Component);

  return WithDirectionComponent;
};
